<template>
  <div
    v-if="loaded || (test && test.is_camera_required && !cameraAllowed && hasAnticheating && getUserMediaStatus)"
    class="interview-test"
    :style="interviewTestStyle"
  >
    <v-app>
      <v-container class="container-fixed">
        <v-row justify="center">
          <v-col :sm="!ended ? 6 : 4" :md="!ended ? 6 : 4" :lg="!ended ? 6 : 4">
            <div :class="cameraCheckBlock ? 'nocamera' : ''" class="inner_wrapper">
              <v-container class="container-fixed">
                <v-row justify="center">
                  <v-col sm="4" md="4" lg="4">
                    <template v-if="ended">
                      <testend :item="item" :active_modules="item.active_modules" />
                    </template>

                    <template v-else>
                      <div v-if="cameraCheckBlock" :class="{ 'interview-test__agreement': cameraCheckBlock }">
                        <div class="interview-test__nocamera-head">
                          {{ $tr('interview.tests.init.noCamera.title') }}
                        </div>
                        <div class="interview-test__agreement-text">
                          <div v-if="!cameraCheckInstructions" class="interview-test__nocamera-text">
                            <span>{{ $tr('interview.tests.init.noCamera.text') }}</span>
                          </div>

                          <div v-else class="interview-test__nocamera-text">
                            <span>
                              {{ $tr('interview.tests.init.allowCameraInSettings.text') }}
                            </span>
                          </div>

                          <vbutton
                            v-if="cameraCheckInstructions"
                            :label="$tr('interview.tests.init.allowCameraInSettings.button')"
                            @click="reloadPage()"
                          />
                        </div>

                        <div class="interview-test__nocamera">
                          <img src="/static/icons/no-camera.svg" />
                        </div>
                      </div>

                      <div v-else>
                        <div v-if="test.company && !!test.company.logo && !end_time" class="logo">
                          <img :src="test.company.logo" alt="vcv" />
                        </div>

                        <div v-if="!end_time" class="info-text">
                          <div v-if="test.name !== null && test.name !== ''" class="info-title">
                            {{ test.name }}
                          </div>

                          <div v-else class="info-title">
                            {{ $tr('interview.tests.init.title') }}
                          </div>
                        </div>

                        <div v-if="!started">
                          <agreement v-if="show_agree_data" v-model="check" :country="vacancy_country" class="agree" />
                          <div v-if="hasAnticheating" class="landng_video-agree flex_center agree">
                            <vcheckbox v-model="agree_video" class="margin_right" />
                            <div>
                              {{ $tr('videoInterview.checkVideo.videoAgree') }}
                            </div>
                          </div>

                          <vbutton
                            :label="$tr('interview.tests.init.button.start')"
                            :disabled="isDisabled"
                            @click="start"
                          />
                        </div>

                        <div v-else>
                          <test
                            v-if="q_loaded"
                            :has-anticheating="hasAnticheating"
                            @end="end_test"
                            @screenshots-error="screenshotsError"
                            @timeout="timeout"
                          />
                        </div>
                      </div>
                    </template>
                  </v-col>
                </v-row>
              </v-container>
            </div>

            <!-- <div v-if="ended && !is_record" class="testend-note">
              <div v-html="$tr('interview.end.note2', { link: noteLink })"></div>
            </div> -->
          </v-col>
        </v-row>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import { STORE_PREFIX } from '../constants.js';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import agreement from './components/agreement';
import test from './components/test';
import testend from './components/testend';

export default {
  name: 'Default',

  components: { agreement, test, testend },

  props: {
    interviewTestStyle: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  data() {
    return {
      check: false,
      agree_video: false,
      show_agree_data: false,
      started: false,
      ended: false,
      loaded: false,
      end_time: false,
      show_agree_video: true,
      cameraAllowed: false,
      cameraCheckBlock: false, // показываем блок проверки камеры перед тестом если включен античитинг
      cameraCheckInstructions: false,
      getUserMediaStatus: ''
    };
  },

  computed: {
    ...mapState('landing', ['isLandingLoaded']),

    ...mapGetters(STORE_PREFIX + 'test', {
      test: 'item',
      token: 'token',
      q_loaded: 'questions/loaded'
    }),

    ...mapGetters('landing', {
      landing: 'item',
      landing_token: 'token'
    }),

    ...mapGetters(STORE_PREFIX + 'interview', {
      item: 'item'
    }),

    vacancy_country() {
      return this.item && this.item.vacancy && this.item.vacancy.country ? this.item.vacancy.country.code : null;
    },

    activeModules() {
      if (!this.landing) {
        return null;
      }

      return this.landing.active_modules;
    },

    is_record() {
      if (!this.item.active_modules) {
        return false;
      }
      return this.item.active_modules.find(el => el.id === 'videointerview');
    },

    isDisabled() {
      if (!this.hasAnticheating) {
        if (this.show_agree_data) {
          return !this.check;
        } else {
          return false;
        }
      } else {
        if (this.show_agree_data) {
          return !this.check || !this.agree_video;
        } else {
          return !this.agree_video;
        }
      }
    },

    hasAnticheating() {
      if (!this.activeModules || !this.activeModules.length) {
        return false;
      }

      let has_video = false;

      this.activeModules.forEach(activeModule => {
        if (activeModule.child_modules && activeModule.child_modules.length) {
          activeModule.child_modules.forEach(childModule => {
            if (childModule.id === 'anticheating') {
              has_video = true;
            }
          });
        }
      });
      return has_video;
    },

    company_name() {
      if (this.test && this.test.company) {
        return this.test.company.name;
      } else {
        return false;
      }
    },

    vacancy_name() {
      if (this.item && this.item.vacancy) {
        return this.item.vacancy.name;
      } else {
        return false;
      }
    },

    noteLink() {
      switch (this.current_locale) {
        case 'ru':
          return 'https://www.vcv.me/ru';
        case 'ja':
        case 'jp':
          return 'https://me.vcv.ai/r/jp';
        default:
          return 'https://www.vcv.me/';
      }
    },

    current_locale() {
      return this.$store.getters['locale/current'];
    },

    publicToken() {
      if (this.item.vacancy !== undefined) {
        if (this.item.vacancy.public_token !== undefined) {
          return this.item.vacancy.public_token;
        }
      }

      return false;
    }
  },

  watch: {
    agree_video() {
      localStorage.setItem('agree_video_' + this.token, true);
    },

    ended(val) {
      if (val && !this.is_record) {
        if (window.gtag) {
          window.gtag({ event: 'response_received' });
        }
      }
    },

    async getUserMediaStatus(value) {
      if (value === 'success') {
        this.cameraAllowed = true;
        this.cameraCheckBlock = false;

        if (this.test.date_start === null) {
          await this.start();
        } else {
          await this.load_questions();
        }
      } else if (
        value === 'NotAllowedError' ||
        value === 'AbortError' ||
        value === 'NotFoundError' ||
        value === 'NotReadableError' ||
        value === 'OverconstrainedError' ||
        value === 'SecurityError' ||
        value === 'TypeError'
      ) {
        this.cameraCheckInstructions = true;
      } else if (value === 'UnsupportedBrowserError') {
        // Браузер не поддерживает запись видео
        this.cameraCheckInstructions = true;
      }
    }
  },

  async created() {
    if (this.publicToken && !this.isLandingLoaded) {
      await this.load(this.publicToken);
    }

    this.open_registration_title();
    this.set_local_storage();
  },

  methods: {
    ...mapMutations('tests_test/questions', ['set_loading']),

    ...mapActions('landing', ['load']),

    async start() {
      if (this.test.is_camera_required && !this.cameraAllowed && this.hasAnticheating) {
        this.cameraCheckBlock = true;

        this.allowCamera();
      } else {
        localStorage.setItem('agree_' + this.token, true);

        await this.$store.dispatch(STORE_PREFIX + 'test/start').then(async () => {
          await this.load_questions();
          localStorage.removeItem('agree_video_' + this.landing_token);
        });
      }
    },

    screenshotsError() {
      if (this.test.is_camera_required) {
        this.cameraAllowed = false;
        this.cameraCheckBlock = true;
        this.allowCamera();
      }
    },

    reloadPage() {
      document.location.reload();
    },

    allowCamera() {
      const constraints = { audio: false, video: { facingMode: 'user' } };

      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }

      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.mediaDevices.getUserMedia ||
        null;

      if (navigator.getUserMedia !== null) {
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(() => {
            this.getUserMediaStatus = 'success';
          })
          .catch(err => {
            this.getUserMediaStatus = err.name;
          });
      } else {
        this.getUserMediaStatus = 'UnsupportedBrowserError';
      }
    },

    async load_questions() {
      this.started = true;
      this.loaded = true;
      await this.$store.dispatch(STORE_PREFIX + 'test/questions/load', this.token);
    },

    end_test() {
      this.set_loading(true);

      this.$store
        .dispatch(STORE_PREFIX + 'test/end')
        .then(() => {
          this.ended = true;
          return this.$store.dispatch(STORE_PREFIX + 'interview/load', this.token);
        })
        .finally(() => {
          this.set_loading(false);
        });
    },

    timeout() {
      this.end_time = true;
      this.$store.dispatch(STORE_PREFIX + 'test/end');
    },

    open_registration_title() {
      if (this.company_name && this.vacancy_name) {
        let title = this.$tr('pageTitles.prefix');
        title = `${this.vacancy_name}. ${this.company_name} - ${title}`;
        document.title = title;
      }
    },

    async set_local_storage() {
      let agree = localStorage.getItem('agree_' + this.token);
      this.show_agree_data = !localStorage.getItem('agree_' + this.token);
      this.show_agree_video = !localStorage.getItem('agree_video_' + this.token);

      if (this.hasAnticheating) {
        agree = localStorage.getItem('agree_' + this.token) && localStorage.getItem('agree_video_' + this.token);
      }

      if (agree && this.test.date_start === null) {
        await this.start();
      } else if (this.test.date_start !== null) {
        if (this.test.is_camera_required && !this.cameraAllowed && this.hasAnticheating) {
          this.cameraCheckBlock = true;

          this.allowCamera();
        } else {
          await this.load_questions();
        }
      } else {
        this.loaded = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.interview-test {
  background-color: #e5e5e5;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 2vw 0;
  min-width: 320px;

  @media (max-width: 1023px) {
    background: #fff;
    padding: 0 12px;
  }

  @media (max-width: 1023px) {
    ::v-deep {
      .container-fixed .col-sm-6,
      .container-fixed .col-sm-4 {
        max-width: 100% !important;
      }
      .v-application--wrap {
        overflow-x: hidden;
      }
    }
  }

  ::v-deep .v-application--wrap {
    min-height: calc(100vh - 4vw - 61px);
  }

  &__agreement {
    width: 130%;
    margin-left: -15%;
    display: flex;
    justify-content: space-between;
    position: relative;

    @media (max-width: 900px) {
      flex-direction: column;
      align-items: center;
    }
  }

  &__agreement-text {
    width: 55%;
    padding-right: 5%;

    @media (max-width: 900px) {
      padding: 0;
      text-align: center;
      order: 2;
      margin-top: 15px;
    }

    .vbutton {
      margin-top: 10px;
    }
  }

  &__nocamera-head {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 28px;
    color: #233346;
    position: absolute;
    top: -45px;
    left: 0;

    @media (max-width: 900px) {
      left: 50%;
      transform: translateX(-50%);
    }

    @media (max-width: 500px) {
      top: -65px;
      text-align: center;
    }
  }

  &__nocamera-text {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    color: #233346;

    @media (max-width: 900px) {
      text-align: center;
    }

    span {
      display: inline-block;
      margin-bottom: 10px;
    }
  }

  &__nocamera {
    background: #f4f5f7;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45%;
    height: 290px;

    img {
      width: 100px;
    }
    @media (max-width: 900px) {
      order: 1;
    }
    @media (max-width: 500px) {
      height: 170px;

      img {
        width: 70px;
      }
    }
  }

  .container-fixed {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .inner_wrapper {
    position: relative;
    background-color: #fff;
    padding: 52px 0;
    box-sizing: border-box;
    margin: auto 0;
    min-width: 320px;
    width: 100%;

    &.nocamera {
      padding: 120px 0 80px;
    }

    .logo {
      height: 60px;
      max-height: 60px;
      min-height: 60px;
      margin-bottom: 52px;
      img {
        height: 100%;
      }

      @media (max-width: 1000px) {
        text-align: center;
      }
    }

    .info-text {
      .info-title {
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 24px;
        line-height: 32px;
        color: #233346;
      }
    }

    .agree {
      margin-bottom: 30px;
    }
  }

  ::v-deep .theme--light.v-application {
    background: transparent !important;
  }
}

.landng_video-agree {
  margin-top: 15px;
  display: flex;
  align-items: center;
}

.margin_right {
  margin-right: 10px;
}

.testend-note {
  margin-top: 8px;
  margin-left: 20px;
  margin-right: 20px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  color: #233346;

  div {
    margin-bottom: 13px;
  }

  ::v-deep a {
    color: #bc89e6;

    &:hover {
      color: #bc89e6;
    }
  }
}
</style>
